
const aerospaceProducts = [
  {
    id: "01",
    title: "Military Aircraft",
    image: "/Military Aircraft.jpg",
    description:
      "Advanced military aircraft designed for combat, transport, surveillance and specialised defence missions.",
    products: [
      "Fighter Aircraft",
      "Trainer Aircraft",
      "Transport Aircraft",
      "Special Mission Aircraft",
      "Reconnaissance Aircraft",
      "Support Aircraft",
    ],
  },

  {
    id: "02",
    title: "Unmanned Aerial Systems",
    image: "/Unmanned Aerial Systems.jpg",
    description:
      "Modern unmanned aerial platforms supporting intelligence, surveillance and tactical operations.",
    products: [
      "Tactical UAVs",
      "Reconnaissance UAVs",
      "Long Endurance UAVs",
      "Surveillance Drones",
      "Mission Control Systems",
    ],
  },

  {
    id: "03",
    title: "Airborne Weapon Systems",
    image: "/Airborne Weapon Systems.jpg",
    description:
      "Precision airborne weapon technologies supporting modern air operations.",
    products: [
      "Air-to-Air Weapons",
      "Air-to-Ground Weapons",
      "Guided Bombs",
      "Missile Systems",
      "Weapon Integration",
    ],
  },

  {
    id: "04",
    title: "Avionics & Electronics",
    image: "/Avionics & Electronics.jpg",
    description:
      "Integrated avionics systems improving aircraft performance, navigation and mission effectiveness.",
    products: [
      "Flight Control Systems",
      "Navigation Systems",
      "Mission Computers",
      "Radar Systems",
      "Electronic Warfare",
    ],
  },

  {
    id: "05",
    title: "Aircraft Maintenance",
    image: "/Aircraft Maintenance.jpg",
    description:
      "Engineering solutions supporting aircraft maintenance, upgrades and operational readiness.",
    products: [
      "Maintenance Support",
      "Aircraft Upgrades",
      "Inspection Services",
      "Repair Facilities",
      "Engineering Solutions",
    ],
  },

  {
    id: "06",
    title: "Ground Support Equipment",
    image: "/Ground Support Equipment.jpg",
    description:
      "Ground support technologies enabling safe and efficient aircraft operations.",
    products: [
      "Ground Power Units",
      "Aircraft Tugs",
      "Support Vehicles",
      "Maintenance Equipment",
      "Testing Systems",
    ],
  },
];

export default aerospaceProducts;